/**
 * Проверяет, что значение является корректным timestamp.
 * Возвращает true, если строка/число состоит только из цифр и имеет длину 10 или 13 символов.
 */
export function isValidTimestamp(raw: unknown): boolean {
  const s = String(raw ?? '');
  return /^\d{10}(\d{3})?$/.test(s);
}
